// Circular dependency'yi kırmak için store referansını runtime'da inject et
// store.ts store'u oluşturduktan sonra setStore() çağırır
// axiosInstance.ts gibi store'u import edemeyecek dosyalar getMobileToken() kullanır

let _mobileToken: string | null = null;

export const setMobileTokenAccessor = (token: string | null) => {
  _mobileToken = token;
};

export const getMobileToken = () => _mobileToken;